import React from 'react';
import { darken, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../../partials/Logo';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: '1rem',
    minHeight: 10,
    [theme.breakpoints.down('md')]: {
      paddingTop: 12,
      paddingBottom: 12,
    },
    '& .Cmt-appIcon': {
      color: theme.palette.text.secondary,
      '&:hover, &:focus': {
        color: darken(theme.palette.text.secondary, 0.2),
      },
      [theme.breakpoints.down('xs')]: {
        padding: 7,
      },
    },
    '& .Cmt-horizontalNavMenu': {
      position: 'static',
      '& .Cmt-navMegaBtn, & > .Cmt-navCollapse > .Cmt-navCollapseBtn': {
        minHeight: 64,
      },
    },
  },
}));

const MainHeader = () => {
  const classes = useStyles();

  return (
    <Toolbar className={classes.root}>
      <Logo mr={{ xs: 2, sm: 4, lg: 6, xl: 8 }} color="white" />
    </Toolbar>
  );
};

export default MainHeader;
